import axios from "axios";
import { API } from "@/lib/api";

export const ADMIN_TOKEN_KEY = "wp_admin_token";

export const adminApi = axios.create({ baseURL: `${API}/admin`, timeout: 60000 });

adminApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      if (!window.location.pathname.endsWith("/admin/login")) {
        window.location.assign("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

// Download an authenticated CSV (blob) and trigger a browser download.
export async function downloadCsv(path, filename) {
  const { data } = await adminApi.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
